import React from 'react';
import classnames from 'classnames';

import './VersionNumber.less';

const UEVersion = withlocals_version;

interface VersionNumberProps {
  hasContent?: boolean;
  isMobile?: boolean;
}

const VersionNumber = ({ hasContent, isMobile }: VersionNumberProps) => {
  if (!UEVersion) {
    return null;
  }
  const classes = classnames(
    'versionNumber text-normal text-smaller text-right color-black-30 space-4-top',
    { 'versionNumber--normal': !!hasContent, 'versionNumber--empty': !hasContent, 'versionNumber--mobile': isMobile });
  return (
    <div className={classes}>
      v{UEVersion}
    </div>);
};

export default VersionNumber;
